function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "75",
  height: "53",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("rect", {
  x: "1.042",
  y: ".5",
  width: "73.25",
  height: "52",
  rx: "2.313",
  fill: "#FAFAFA"
}), /*#__PURE__*/React.createElement("rect", {
  x: "5.62",
  y: "5.945",
  width: "64.094",
  height: "27.094",
  rx: "1.359",
  fill: "#E8EAED",
  stroke: "#DDE0E4",
  strokeWidth: ".906"
}), /*#__PURE__*/React.createElement("rect", {
  x: "22.271",
  y: "39.74",
  width: "25.375",
  height: "4.531",
  rx: "2.266",
  fill: "#DDE0E4"
}), /*#__PURE__*/React.createElement("circle", {
  cx: "12.889",
  cy: "41.765",
  r: "5.743",
  fill: "#DDE0E4"
}), /*#__PURE__*/React.createElement("mask", {
  id: "a",
  style: {
    maskType: "alpha"
  },
  maskUnits: "userSpaceOnUse",
  x: "7",
  y: "36",
  width: "12",
  height: "12"
}, /*#__PURE__*/React.createElement("circle", {
  cx: "12.889",
  cy: "41.765",
  r: "5.743",
  fill: "#D9D9D9"
})), /*#__PURE__*/React.createElement("g", {
  mask: "url(#a)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14.834 40.258a1.94 1.94 0 01-1.942 1.938 1.94 1.94 0 01-1.94-1.938c0-1.07.868-1.938 1.94-1.938a1.94 1.94 0 011.942 1.938zm-1.278 3.207a2.779 2.779 0 012.781 2.776v.695l-.861.86-3.25.485-1.92-.484-.86-.861v-.695a2.779 2.779 0 012.78-2.776h1.33z",
  fill: "#FAFAFA"
})), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M37.25 25.92a6.162 6.162 0 100-12.325 6.162 6.162 0 000 12.325zm0 1.088a7.25 7.25 0 100-14.5 7.25 7.25 0 000 14.5z",
  fill: "#7E86A0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M39.46 19.266l-2.463-1.626a.725.725 0 00-1.125.605v3.251c0 .578.643.924 1.125.606l2.463-1.626a.725.725 0 000-1.21z",
  fill: "#7E86A0"
}), /*#__PURE__*/React.createElement("rect", {
  x: "1.042",
  y: ".5",
  width: "73.25",
  height: "52",
  rx: "2.313",
  stroke: "#DDE0E4"
})));